import { getInitialAdminStoreState } from '@/store/modules/admin/helpers/getInitialAdminStoreState';

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: getInitialAdminStoreState(),
  getters,
  mutations,
  actions,
}
